import React from 'react';
import { Loader } from 'freemium-ui';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import NewButton from '../../../routes/components/NewButton';
import {
  AccountInfoType,
  AccountUserType,
  BreadcrumpDataType,
  ConfirmationType,
} from '../../types';
import { useGetContactForm } from '../../hooks';
import Icon from '../Icon';
import DashboardBreadcrump from './DashboardBreadcrump';
import LocationBreadcrump from './LocationBreadcrump';
import Profile from './UserDropdown';

type HeaderProps = {
  setActionTime?: (time: string) => void;
  setBreadcrumpData?: (
    str: BreadcrumpDataType | React.SetStateAction<BreadcrumpDataType>,
  ) => void;
  setConfirmationData: (
    str: ConfirmationType | React.SetStateAction<ConfirmationType>,
  ) => void;
  breadcrumpData?: BreadcrumpDataType;
  accountInfo?: AccountInfoType;
  currentAccountUser?: AccountUserType;
  contactsCount: number;
  fetchContactCount: () => void;
};

const Header = (props: HeaderProps) => {
  const {
    breadcrumpData,
    setBreadcrumpData,
    setActionTime,
    setConfirmationData,
    accountInfo,
    currentAccountUser,
    contactsCount,
    fetchContactCount,
  } = props;

  const location = useLocation();

  const {
    data: contactForm = {},
    isLoading: isLoadingContactForm,
    isError: isContactFormError,
  } = useGetContactForm();
  const fields = React.useMemo(() => contactForm?.fields || [], [contactForm]);

  return (
    <StyledHeader>
      {location.pathname === '/dashboard' && currentAccountUser ? (
        <DashboardBreadcrump currentAccountUser={currentAccountUser} />
      ) : location.pathname === '/settings/design-themes' &&
        currentAccountUser ? (
        <LocationBreadcrump
          setBreadcrumpData={() => {}}
          currentAccountUser={currentAccountUser}
        />
      ) : (
        <LocationBreadcrump
          breadcrumpData={breadcrumpData}
          setBreadcrumpData={setBreadcrumpData}
          currentAccountUser={currentAccountUser}
        />
      )}
      <HeaderActions>
        {isLoadingContactForm ? (
          <Loader size="small" />
        ) : (
          <NewButton
            fields={fields}
            disabled={isContactFormError}
            setConfirmationData={setConfirmationData}
            executeSegment={() => {
              if (setActionTime) setActionTime(new Date().toISOString());
              fetchContactCount();
            }}
            accountInfo={accountInfo}
            contactsCount={contactsCount}
          />
        )}
        <div className="announcement-mount" id="beamer-mount">
          <Icon fill="#264966" width="16" height="16" glyph="gift-box" />
        </div>
        <Profile />
      </HeaderActions>
    </StyledHeader>
  );
};

const StyledHeader = styled.header`
  height: 60px;
  background-color: white;
  display: flex;
  align-items: center;
  z-index: 1100;
  padding: 0 14px;
  justify-content: space-between;
  border-bottom: 1px #ebeff3 solid;

  .announcement-mount {
    height: 32px;
    width: 32px;
    cursor: pointer;
    display: grid;
    place-content: center;
    margin-left: 14px;

    &:hover {
      opacity: 0.8;
    }

    .beamer_icon.active,
    #beamerIcon.active {
      top: -7px;
      left: 12px;
    }
  }
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  button {
    margin: 0;
  }
`;

export default Header;
